import {callAPI, createActions} from '../../../../commons/actions/data-action-helper'
import {navigateToGroup} from '../../../../commons/services/navigation'
import {getEvent} from '../selectors/event'
import {getGroupId, getGroupSlug} from '../selectors/groups'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState} from '../types/state'

export const GET_CONNECTED_GROUP_OLD = createActions('GET_CONNECTED_GROUP_OLD')
export const GET_GROUP_ACTIVITY_OLD = createActions('GET_GROUP_ACTIVITY_OLD')

export const getConnectedGroupOld = () => async (dispatch: Function, getState: GetState) => {
  try {
    const eventId = getEvent(getState()).id

    if (eventId && !eventId.includes('demo')) {
      const response = await dispatch(callAPI(GET_CONNECTED_GROUP_OLD, eventId))

      if (response && response.group?.id) {
        return dispatch(getGroupActivityOld({groupId: response.group.id}))
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export const getConnectedGroup = createAsyncAction(
  'GET_CONNECTED_GROUP',
  async (_, {getState, dispatch, extra: {serverApi}}) => {
    const eventId = getEvent(getState()).id

    if (eventId && !eventId.includes('demo')) {
      const response = await serverApi.getGroup(eventId)

      if (response && response.group?.id) {
        await dispatch(getGroupActivity(response.group.id))
      }

      return response
    }
  },
)

export const getGroupActivityOld =
  ({groupId}: {groupId: string}) =>
  (dispatch: Function) =>
    dispatch(callAPI(GET_GROUP_ACTIVITY_OLD, groupId))

export const getGroupActivity = createAsyncAction('GET_GROUP_ACTIVITY', async (groupId: string, {extra: {serverApi}}) =>
  serverApi.getGroupActivity(groupId),
)

export const joinGroup = createAsyncAction('JOIN_GROUP', async (_, {getState, extra: {wixCodeApi}}) => {
  const state = getState()
  const groupId = getGroupId(state)
  const slug = getGroupSlug(state)

  await navigateToGroup(slug, groupId, wixCodeApi)
})
